import React, { useState } from "react";
import "./customNavbar.css";
import company_logo from "../../assets/with_background_logo.png";
import { GiHamburgerMenu } from "react-icons/gi";
import { RiCloseLargeFill } from "react-icons/ri";

function CustomNavbar() {
  const [drawerVisible, setDrawerVisible] = useState(false);

  return (
    <div className="custom-navbar">
      <div className="custom-navbar-left">
        <div className="custom-navbar-hamburger" onClick={() => setDrawerVisible(true)}>
          <GiHamburgerMenu size={26} />
        </div>
        <img src={company_logo} alt="MediQNow Logo" className="custom-navbar-logo" />
      </div>

      <div className="custom-navbar-center">
        <a href="#home">Home</a>
        <a href="#features">Features</a>
        <a href="#hospitals_&_clinics">Hospitals & Clinics</a>
        <a href="#lab_&_medicalshops">Laboratory & Medical Shops</a>
        <a href="#about">About Us</a>
        <a href="#contact_us">Contact</a>
      </div>

      <div className="custom-navbar-right">
        <button className="custom-navbar-btn-outline">Login / Sign Up</button>
        <button className="custom-navbar-btn-filled">Download App</button>
      </div>

      {/* Drawer */}
      <div className={`custom-navbar-drawer ${drawerVisible ? "open" : ""}`}>
        <div className="custom-navbar-drawer-header">
          <img src={company_logo} alt="Logo" className="custom-navbar-logo" />
          <RiCloseLargeFill
            className="custom-navbar-drawer-close"
            onClick={() => setDrawerVisible(false)}
          />
        </div>
        <div className="custom-navbar-drawer-links">
        <a href="#home"  onClick={() => setDrawerVisible(false)}>Home</a>
        <a href="#features"  onClick={() => setDrawerVisible(false)}>Features</a>
        <a href="#hospitals_&_clinics"  onClick={() => setDrawerVisible(false)}>Hospitals & Clinics</a>
        <a href="#lab_&_medicalshops"  onClick={() => setDrawerVisible(false)}>Laboratory & Medical Shops</a>
        <a href="#about"  onClick={() => setDrawerVisible(false)}>About Us</a>
        <a href="#contact_us"  onClick={() => setDrawerVisible(false)}>Contact</a>
          <button className="custom-navbar-btn-filled-drawer"  onClick={() => setDrawerVisible(false)}>Download App</button>
        </div>
      </div>

      {/* Overlay */}
      {drawerVisible && <div className="custom-navbar-overlay" onClick={() => setDrawerVisible(false)} />}
    </div>
  );
}

export default CustomNavbar;
